import { createFileRoute } from '@tanstack/react-router'
import { DidSuspensionsPage } from '@/features/operations/did-suspensions'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/did-suspensions/')({
  component: DidSuspensionsPage,
  beforeLoad: requireRole(['admin']),
})
